import signAudit from './signAudit'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...signAudit
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/messageManage/index.js